import {
  canEnableNotifications,
  notificationSetupCopy,
  type NotificationSetupState,
} from '../../lib/notificationSetup';

type Props = {
  setupState: NotificationSetupState;
  onEnable: () => void;
  onDismiss: () => void;
  webPushConfigured: boolean;
  className?: string;
};

export function NotificationPermissionPrompt({
  setupState,
  onEnable,
  onDismiss,
  webPushConfigured,
  className,
}: Props) {
  if (setupState === 'granted') return null;

  const { title, message } = notificationSetupCopy(setupState);
  const canEnable = canEnableNotifications(setupState);

  return (
    <div
      className={[
        'notification-permission',
        setupState === 'insecure' ? 'notification-permission--warn' : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      role="region"
      aria-label="Enable notifications"
    >
      <div className="notification-permission__text">
        <strong>{title}</strong>
        <span>
          {message}
          {canEnable && webPushConfigured
            ? ' Allow once on this device. You will only get alerts for portals you have permission to open.'
            : ''}
        </span>
      </div>
      <div className="notification-permission__actions">
        {canEnable && (
          <button type="button" className="btn-primary btn-sm" onClick={onEnable}>
            Enable notifications
          </button>
        )}
        <button type="button" className="btn-secondary btn-sm" onClick={onDismiss}>
          {canEnable ? 'Not now' : 'Dismiss'}
        </button>
      </div>
    </div>
  );
}
